import React, { useEffect, useState } from "react";
import { LinkedinShareButton, LinkedinIcon, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from "react-share";
import { useTranslation } from "../../locale/useTranslation";

const SMSharePostForm = ({ item, type, onClose }) => {

    const lang = useTranslation();
    const defaultUrl = item?.creatives?.[0]?.url || "";
    const defaultThumbnail = item?.creatives?.[0]?.thumbnailUrl || "https://via.placeholder.com/400x200?text=No+Image";

    const [showCreatePost, setShowCreatePost] = useState(false);
    const [thumbnailUrl, setThumbnailUrl] = useState(defaultThumbnail);

    const [dataItem, setDataItem] = useState({
        quote: item?.quote || item?.description || "",
        hashtag: item?.hashtag || "#sale",
        title: item?.title || "",
        summary: item?.description || "",
        source: item?.brand?.Name || "",
        url: defaultUrl,
        shareUrl: defaultUrl, 
    });

    const getActualUrl = (url) => {
        try {
            const parsed = new URL(url);
            if (parsed.hostname.includes("google.com") && parsed.pathname === "/imgres") {
                const params = new URLSearchParams(parsed.search);
                const actualImgUrl = params.get("imgurl");
                if (actualImgUrl) {
                    return decodeURIComponent(actualImgUrl);
                }
            }
        } catch (e) {
            console.error("Invalid URL:", url);
        }
        return url;
    };

    const getYouTubeThumbnail = (url) => {
        try {
            const parsedUrl = new URL(url);
            if (parsedUrl.hostname.includes("youtube.com") || parsedUrl.hostname === "youtu.be") {
                let videoId = null;
                if (parsedUrl.hostname === "youtu.be") {
                    videoId = parsedUrl.pathname.slice(1);
                } else {
                    videoId = parsedUrl.searchParams.get("v");
                }
                if (videoId) {
                    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                }
            }
        } catch {
        }
        return null;
    };

    useEffect(() => {
        console.log("Current URL:", dataItem.url);
        const extractedUrl = getActualUrl(dataItem.url);
        console.log("Extracted URL:", extractedUrl);
      
        const youTubeThumbnail = getYouTubeThumbnail(extractedUrl);
        console.log("YouTube Thumbnail:", youTubeThumbnail);
      
        if (youTubeThumbnail) {
          setThumbnailUrl(youTubeThumbnail);
        } else if (!extractedUrl || extractedUrl === defaultUrl) {
          setThumbnailUrl(defaultThumbnail);
        } else {
          setThumbnailUrl(extractedUrl);
        }
      }, [dataItem.url, defaultThumbnail, defaultUrl]);
      

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem((prev) => ({ ...prev, [name]: value }));
    };

    const platformConfig = {
        meta: {
            label: "Facebook",
            icon: "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png",
            fields: [ { value: dataItem.quote }, { value: dataItem.hashtag }],
        },
        linkedin: {
            label: "LinkedIn",
            icon: "https://img.icons8.com/color/48/linkedin.png",
            fields: [ { value: dataItem.title }, { value: dataItem.source }, { value: dataItem.summary }],
        },
        google: {
            label: "Google",
            icon: "https://img.icons8.com/color/48/google-logo.png",
            fields: [],
        },
        youtube: {
            label: "YouTube",
            icon: "https://img.icons8.com/color/48/youtube-play.png",
            fields: [ { value: dataItem.title } ],
        },
        snapchat: {
            label: "Snapchat",
            icon: "https://img.icons8.com/color/48/snapchat.png",
            fields: [],
        },
    };

    const config = platformConfig[type];
    if (!config) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", maxHeight: "200vh" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content rounded-4 shadow p-1">
                    <div className="modal-header border-0">
                        <h5 className="modal-title" style={{ marginTop: "-10px", fontWeight: "700" }}>{lang.share_post_label} </h5>
                        <button type="button" onClick={onClose}
                            style={{ background: "transparent", border: "none", fontSize: "1.5rem", lineHeight: "1", color: "#333", fontWeight: "bold", cursor: "pointer", marginTop: "-10px" }}
                            aria-label="Close"
                        > &times; 
                        </button>
                    </div>

                    <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                        <button className="btn btn-light w-100 mb-2" onClick={() => setShowCreatePost(true)}>{lang.create_post_button} </button>
                        {showCreatePost && (
                            <div className='mt-2'>
                                <div className="d-flex items-center justify-content-between">
                                    <div className="small text-secondary fw-bold"> {`Create ${type} post`} </div>
                                    <button type="button"  onClick={() => setShowCreatePost(false)}
                                        style={{ background: "transparent", border: "none", lineHeight: "1", color: "#333", cursor: "pointer" }}
                                        aria-label="Close"
                                    > &times;
                                     </button>
                                </div>
                                <div className="border bg-white rounded shadow-sm p-3 mb-3">
                                    {type === "meta" && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label>{lang.quote_label}</label>
                                                    <input className="form-control" name="quote" value={dataItem.quote} onChange={onChange} />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label>{lang.hashtag_label}</label>
                                                    <input className="form-control" name="hashtag" value={dataItem.hashtag} onChange={onChange} />
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label>{lang.url_label}</label>
                                                    <input className="form-control" name="url" value={dataItem.url} onChange={onChange} />
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <FacebookShareButton url={getActualUrl(dataItem.url)} quote={dataItem.quote} hashtag={dataItem.hashtag}>
                                                    <button className="btn btn-primary">{lang.share_on_facebook_button}</button>
                                                </FacebookShareButton>
                                            </div>
                                        </>
                                    )}

                                    {type === "linkedin" && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label>{lang.title_label}</label>
                                                    <input className="form-control" name="title" value={dataItem.title} onChange={onChange} />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label>{lang.source_label}</label>
                                                    <input className="form-control" name="source" value={dataItem.source} onChange={onChange} />
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <label>{lang.summary_label}</label>
                                                    <textarea className="form-control" name="summary" value={dataItem.summary} onChange={onChange} />
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label>{lang.url_label}</label>
                                                    <input className="form-control" name="url" value={dataItem.url} onChange={onChange} />
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <LinkedinShareButton
                                                    url={getActualUrl(dataItem.url)}
                                                    title={dataItem.title}
                                                    summary={dataItem.summary}
                                                    source={dataItem.source}
                                                >
                                                    <button className="btn btn-primary">{lang.share_on_linkedin_button}</button>
                                                </LinkedinShareButton>
                                            </div>
                                        </>
                                    )}

                                    {["google", "youtube", "snapchat"].includes(type) && (
                                        <>
                                            <label>{lang.share_url_label}</label>
                                            <input className="form-control mb-2" name="shareUrl" value={dataItem.shareUrl} onChange={onChange} />
                                            <div className="text-end mt-2">
                                                <a
                                                    href={dataItem.shareUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-warning"
                                                >
                                                    Open {type.charAt(0).toUpperCase() + type.slice(1)} Share
                                                </a>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}

                        <hr />
                        <p className="mb-2">{lang.share_this_link_via_label}</p>
                        <div className=" mb-3" style={{ display: 'flex', justifyContent: 'start', alignItems: 'start', gap: '10px' }}>
                            <LinkedinShareButton url={getActualUrl(dataItem.url)} title={dataItem.title} summary={dataItem.summary} source={dataItem.source}>
                                <LinkedinIcon size={40} round />
                            </LinkedinShareButton>
                            <FacebookShareButton url={getActualUrl(dataItem.url)} quote={dataItem.quote} hashtag={dataItem.hashtag}>
                                <FacebookIcon size={40} round />
                            </FacebookShareButton>
                            <TwitterShareButton url={getActualUrl(dataItem.url)} title={dataItem.title}>
                                <TwitterIcon size={40} round />
                            </TwitterShareButton>
                            <WhatsappShareButton url={getActualUrl(dataItem.url)} title={dataItem.title}>
                                <WhatsappIcon size={40} round />
                            </WhatsappShareButton>
                            <a
                                href={`https://plus.google.com/share?url=${encodeURIComponent(getActualUrl(dataItem.url))}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Google Share"
                            >
                                <img src="https://img.icons8.com/color/48/google-logo.png" alt="Google" style={{ borderRadius: "40%", marginTop: "-3px" }} />
                            </a>
                            <a
                                href={`https://www.youtube.com/watch?v=${encodeURIComponent(getActualUrl(dataItem.url))}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="YouTube Share"
                            >
                                <img src="https://img.icons8.com/color/48/youtube-play.png" alt="YouTube" style={{ borderRadius: "40%", marginTop: "-3px" }}/>
                            </a>
                            <a
                                href={`https://snapchat.com/share?text=${encodeURIComponent(getActualUrl(dataItem.url))}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Snapchat Share"
                            >
                                <img src="https://img.icons8.com/color/48/snapchat.png" alt="Snapchat" style={{ borderRadius: "40%", marginTop: "-3px" }} />
                            </a>
                        </div>
                        <div className="border p-3 shadow-sm bg-white rounded-3">
                            <div className="d-flex align-items-center mb-2">
                                <img src={config.icon} alt={`${type} icon`} style={{ width: 24, height: 24, marginRight: 8 }} />
                                <strong>{config.label}</strong>
                            </div>

                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                    <img
                                        src={item?.logoUrl || "https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"}
                                        alt="Logo"
                                        style={{ width: "2.5rem", height: "1.5rem", marginRight: "0.5rem" }}
                                    />
                                    <div>
                                        <div className="fw-bold">Bright Media Solution</div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2" style={{ backgroundColor: "#ddd", height: 180, textAlign: "center" }}>
                                {thumbnailUrl ? (
                                    <img src={thumbnailUrl} alt="Preview" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                                        <i className="bi bi-film" style={{ fontSize: 48 }}></i>
                                    </div>
                                )}
                            </div>
                            {type === "linkedin" && (
                                <div className="row text-dark">
                                    <div className="col-4 text-start">
                                        <strong>{dataItem.title}</strong>
                                    </div>
                                    <div className="col-4 text-center">
                                        <strong>{dataItem.source}</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        <strong>{dataItem.summary}</strong>
                                    </div>
                                </div>
                            )}
                            {type === "meta" && (
                                <div className="row text-dark mt-2">
                                    <div className="col-6 text-start">
                                        <strong>{dataItem.quote}</strong>
                                    </div>
                                    <div className="col-6 text-end">
                                        <strong>{dataItem.hashtag}</strong>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SMSharePostForm;







